import React, { useState } from "react";
import { motion } from "framer-motion";
import "../styles/ServiciosCarrusel.css";

const servicios = [
  {
    nombre: "Corte & Lavado",
    precio: { corto: 15000, medio: 18000, largo: 18000, extraLargo: 18000 },
    detalle: [
      "Corte — $15.000",
      "Lavado + Corte — $18.000",
      "Nutrición — $20.000"
    ]
  },
  {
    nombre: "Keratina",
    precio: { corto: 35000, medio: 40000, largo: 45000, extraLargo: 50000 }
  },
  {
    nombre: "Color",
    precio: { corto: 35000, medio: 40000, largo: 50000, extraLargo: 50000 },
    detalle: [
      "Raíz — $35.000",
      "Corto — $35.000",
      "Medio — $40.000",
      "Largo — $50.000"
    ]
  },
  {
    nombre: "Mechas / Balayage",
    precio: { corto: 45000, medio: 50000, largo: 65000, extraLargo: 85000 }
  },
  {
    nombre: "Ondulaciones",
    precio: { corto: 45000, medio: 50000, largo: 65000, extraLargo: 65000 }
  },
  {
    nombre: "Peinados",
    precio: { corto: 20000, medio: 25000, largo: 35000, extraLargo: 50000 },
    detalle: [
      "Brushing — $20.000",
      "Peinado ondas / plancha — $25.000",
      "Recogido / trenzas — $35.000",
      "Novias · 15 años · Egresos — $50.000"
    ]
  },
];

const ServiciosCarrusel = () => {
  const [selectedService, setSelectedService] = useState(null);

  const toggleService = (index) => {
    setSelectedService(selectedService === index ? null : index);
  };

  return (
    <div className="carrusel-container">
      <div className="carrusel-track">
        {servicios.map((servicio, index) => (
          <motion.div
            key={index}
            className="carta-servicio"
            onClick={() => toggleService(index)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
          >
            <h3 className="nombre-servicio">{servicio.nombre}</h3>
            <p className="precio-servicio">
              Desde ${servicio.precio.corto}
            </p>

            {selectedService === index && (
              <motion.div
                className="price-list active"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <p>Corto: ${servicio.precio.corto}</p>
                <p>Medio: ${servicio.precio.medio}</p>
                <p>Largo: ${servicio.precio.largo}</p>
                <p>Extra largo: ${servicio.precio.extraLargo}</p>

                {servicio.detalle && (
                  <div className="detalle-servicio">
                    <hr />
                    {servicio.detalle.map((linea, i) => (
                      <p key={i}>{linea}</p>
                    ))}
                  </div>
                )}
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ServiciosCarrusel;
